import './TabStyles.css';
import {displayDateOrTimeFromFirebase} from '../../../../utils/datetime';

const PostsTab = ({ posts }) => {
    if (!posts || posts.length === 0) {
        return (
            <div className="tab-empty">
                <p>No posts yet</p>
            </div>
        );
    }

    return (
        <div className="posts-tab">
            {posts.map(post => (
                <article key={post.id} className="post-card">
                    <div className="post-card__header">
                        <span className="post-card__date">{displayDateOrTimeFromFirebase(post.date,'date')}</span>
                    </div>
                    <p className="post-card__content">{post.content}</p>
                    {post.image && (
                        <div className="post-card__image">
                            <img src={post.image} alt="Post" loading="lazy" />
                        </div>
                    )}
                    <div className="post-card__footer">
                        <span className="post-card__stat">
                            <span className="post-card__stat-icon">❤️</span>
                            {post.likes}
                        </span>
                        <span className="post-card__stat">
                            <span className="post-card__stat-icon">💬</span>
                            {post.comments}
                        </span>
                    </div>
                </article>
            ))}
        </div>
    );
};

export default PostsTab;
